<template>
<div>
  <main-header-nav :content="'我的项目'"></main-header-nav>
  <project-cost-estimate-list
    :type="'myself'"
  >
  </project-cost-estimate-list>
</div>
</template>
<script>
import MainHeaderNav from '../common/MainHeaderNav'
import ProjectCostEstimateList from './ProjectCostEstimateList'
export default {
  name: 'MyProjects',

  components: {
    ProjectCostEstimateList, MainHeaderNav
  },

  data () {
    return {
    }
  },

  mounted () {

  }
}
</script>
<style scoped>

</style>
